import React from 'react'
import { redirectTo } from 'frontend_core/dist/helpers/http'
import { getBillingLabel } from 'helper/getBillingLabel'
import { STATUS } from 'modules/reservation'

export default class Reservation extends React.Component {
  constructor(props) {
    super(props)
    this.onClick = this.onClick.bind(this)
  }

  onClick(e) {
    if (e.target.tagName === 'A') {
      e.stopPropagation()
    } else {
      e.preventDefault()
      const { data, reservation } = this.props
      const company = data.company
      redirectTo(
        `/companies/${company.username}/reservations/${reservation.uid}`,
      )
    }
  }

  renderBilling() {
    const { data, reservation } = this.props
    const company = data.company

    const billingLabel = getBillingLabel(reservation)

    if (!billingLabel) return null

    return (
      <a
        href={`/companies/${company.username}/reservations/${
          reservation.uid
        }/billing`}
        className="business-reservation__list-download"
        target="_blank"
      >
        <br className="pc-hide__sm-show" />
        <i className="icon icon-spm-download sm-hide mr5" />
        {billingLabel}
      </a>
    )
  }

  render() {
    const { data, reservation } = this.props
    const company = data.company
    const billing = reservation.billing
    const contact = reservation.user.contact

    return (
      <tr className="business-reservation__line" onClick={this.onClick}>
        <td className="business-reservation__list-request">
          {reservation.createdAtText}
        </td>
        <td className="business-reservation__list-id">{reservation.id}</td>
        <td className="business-reservation__list-user">
          {contact.familyName} {contact.givenName}
        </td>
        <td className="business-reservation__list-day">
          {reservation.startedAtText}
        </td>
        <td className="business-reservation__list-fee">
          {reservation.status === STATUS.REFUNDED
            ? billing.totalCancelAmountForUserWithTaxText
            : billing.totalPayAmountForUserWithTaxText}
        </td>
        <td className="business-reservation__list-status">
          <span className="business-reservation__list-status-text">
            {reservation.statusText}
          </span>
          {this.renderBilling()}
        </td>
      </tr>
    )
  }
}
